export default function HeroSection() {
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-24 md:py-20 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-6">
              <i className="ri-fire-line text-sm"></i>
              <span>日漫·国漫·韩漫 全覆盖</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight">
              51动漫官网
              <span className="block text-2xl md:text-3xl lg:text-4xl text-primary-600 mt-2">
                动漫全集免费下拉式追更平台
              </span>
            </h1>

            <p className="mt-3 text-lg md:text-xl text-foreground-600 font-heading">
              随时随地，想看就看，想下就下
            </p>

            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px] mx-auto lg:mx-0">
              51动漫官网致力于为广大动漫爱好者打造一站式的51动漫在线观看与51动漫下载体验。平台覆盖海量日漫、国漫、韩漫资源，支持动漫全集下拉式阅读模式，无需翻页即可连续追更。每日同步更新最新番剧，确保您不错过任何精彩内容。无论经典老番还是当季热播，51动漫官网都能满足您的追番需求。
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8">
              {[
                { value: '20000+', label: '累计收录动漫' },
                { value: '50+', label: '每日更新新番' },
                { value: '8大类', label: '动漫类型覆盖' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-primary-600">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="mt-7 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => scrollToSection(e, 'cards')}
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始追番
              </a>
              <a
                href="#ranking"
                onClick={(e) => scrollToSection(e, 'ranking')}
                className="inline-flex items-center gap-2 px-7 py-3 border border-background-300 text-foreground-700 font-medium text-sm rounded-full hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-bar-chart-line text-lg"></i>
                热门排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20collage%20featuring%20colorful%20characters%20from%20Japanese%20Chinese%20and%20Korean%20animation%20styles%20in%20vibrant%20warm%20orange%20coral%20amber%20color%20palette%20modern%20streaming%20platform%20design%20with%20play%20button%20and%20UI%20elements%20cinematic%20composition%20soft%20artistic%20rendering%20clean%20background&width=800&height=600&seq=hero-anime-visual&orientation=landscape"
                alt="51动漫官网 — 动漫在线观看与下载"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/15 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}